/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createTenant } from '../fn/tenants/create-tenant';
import { CreateTenant$Params } from '../fn/tenants/create-tenant';
import { createUserInTenant } from '../fn/tenants/create-user-in-tenant';
import { CreateUserInTenant$Params } from '../fn/tenants/create-user-in-tenant';
import { deleteTenant } from '../fn/tenants/delete-tenant';
import { DeleteTenant$Params } from '../fn/tenants/delete-tenant';
import { getTenant } from '../fn/tenants/get-tenant';
import { GetTenant$Params } from '../fn/tenants/get-tenant';
import { listTenants } from '../fn/tenants/list-tenants';
import { ListTenants$Params } from '../fn/tenants/list-tenants';
import { TenantDto } from '../models/tenant-dto';
import { TenantDtoPage } from '../models/tenant-dto-page';
import { updateTenant } from '../fn/tenants/update-tenant';
import { UpdateTenant$Params } from '../fn/tenants/update-tenant';
import { UserDto } from '../models/user-dto';

@Injectable({ providedIn: 'root' })
export class TenantsApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listTenants()` */
  static readonly ListTenantsPath = '/v0/tenants';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listTenants()` instead.
   *
   * This method doesn't expect any request body.
   */
  listTenants$Response(params?: ListTenants$Params, context?: HttpContext): Observable<StrictHttpResponse<TenantDtoPage>> {
    return listTenants(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listTenants$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listTenants(params?: ListTenants$Params, context?: HttpContext): Observable<TenantDtoPage> {
    return this.listTenants$Response(params, context).pipe(
      map((r: StrictHttpResponse<TenantDtoPage>): TenantDtoPage => r.body)
    );
  }

  /** Path part for operation `createTenant()` */
  static readonly CreateTenantPath = '/v0/tenants';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createTenant()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTenant$Response(params: CreateTenant$Params, context?: HttpContext): Observable<StrictHttpResponse<TenantDto>> {
    return createTenant(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createTenant$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTenant(params: CreateTenant$Params, context?: HttpContext): Observable<TenantDto> {
    return this.createTenant$Response(params, context).pipe(
      map((r: StrictHttpResponse<TenantDto>): TenantDto => r.body)
    );
  }

  /** Path part for operation `getTenant()` */
  static readonly GetTenantPath = '/v0/tenants/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTenant()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTenant$Response(params: GetTenant$Params, context?: HttpContext): Observable<StrictHttpResponse<TenantDto>> {
    return getTenant(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTenant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTenant(params: GetTenant$Params, context?: HttpContext): Observable<TenantDto> {
    return this.getTenant$Response(params, context).pipe(
      map((r: StrictHttpResponse<TenantDto>): TenantDto => r.body)
    );
  }

  /** Path part for operation `updateTenant()` */
  static readonly UpdateTenantPath = '/v0/tenants/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTenant()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTenant$Response(params: UpdateTenant$Params, context?: HttpContext): Observable<StrictHttpResponse<TenantDto>> {
    return updateTenant(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateTenant$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTenant(params: UpdateTenant$Params, context?: HttpContext): Observable<TenantDto> {
    return this.updateTenant$Response(params, context).pipe(
      map((r: StrictHttpResponse<TenantDto>): TenantDto => r.body)
    );
  }

  /** Path part for operation `deleteTenant()` */
  static readonly DeleteTenantPath = '/v0/tenants/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteTenant()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTenant$Response(params: DeleteTenant$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteTenant(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteTenant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTenant(params: DeleteTenant$Params, context?: HttpContext): Observable<void> {
    return this.deleteTenant$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createUserInTenant()` */
  static readonly CreateUserInTenantPath = '/v0/tenants/user';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createUserInTenant()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createUserInTenant$Response(params: CreateUserInTenant$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    return createUserInTenant(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createUserInTenant$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createUserInTenant(params: CreateUserInTenant$Params, context?: HttpContext): Observable<UserDto> {
    return this.createUserInTenant$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

}
